module.exports = __webpack_public_path__ + "img/calling.b4233a28.svg";